import { render, staticRenderFns } from "./allTop.vue?vue&type=template&id=f0ca3314&scoped=true&"
import script from "./allTop.vue?vue&type=script&lang=js&"
export * from "./allTop.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./allTop.vue?vue&type=style&index=0&id=f0ca3314&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f0ca3314",
  "819a5336"
  
)

export default component.exports